import { FETCHING_PENDING_EMPLOYEE_BASEJOBS, PENDING_EMPLOYEE_BASEJOBS_FETCHED } from '../actions/pendingEmployeeBaseJob'

const INITIAL_STATE = {
  jobs: { list: [], total: 0 },
  loading: true
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCHING_PENDING_EMPLOYEE_BASEJOBS:
      return handleFetchingJobs(state, action)
    case PENDING_EMPLOYEE_BASEJOBS_FETCHED:
      return handleJobsFetched(state, action)
    default:
      return state
  }
}

function handleFetchingJobs (state, action) {
  const { loading } = action
  return { ...state, loading }
}

function handleJobsFetched (state, action) {
  const { jobs, loading } = action
  return { ...state, jobs, loading }
}
